"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _grid = require("@jsluna/grid");

var _form = require("@jsluna/form");

var _button = require("@jsluna/button");

var _icons = require("@jsluna/icons");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("../../utils/constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var EditChecklistItem = function EditChecklistItem(_ref) {
  var item = _ref.item,
      index = _ref.index,
      checklistItems = _ref.checklistItems,
      newItemTitle = _ref.newItemTitle,
      newItemDescription = _ref.newItemDescription,
      handleTextChange = _ref.handleTextChange,
      handleMoveItem = _ref.handleMoveItem,
      handleRemoveItem = _ref.handleRemoveItem;
  return /*#__PURE__*/_react.default.createElement(_grid.GridWrapper, {
    className: "ln-u-margin-bottom*2"
  }, /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: "1/1"
  }, index === checklistItems.length - 1 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, newItemTitle && /*#__PURE__*/_react.default.createElement("div", {
    className: "ln-u-margin-bottom"
  }, /*#__PURE__*/_react.default.createElement("b", null, newItemTitle)), newItemDescription && /*#__PURE__*/_react.default.createElement("div", {
    className: "ln-u-margin-bottom"
  }, newItemDescription)), /*#__PURE__*/_react.default.createElement(_form.TextInputField, {
    required: true,
    maxLength: 500,
    value: item.text,
    name: "checklist-item-" + item.id,
    className: "ln-u-margin-bottom",
    style: {
      opacity: 1
    },
    onChange: function onChange(e) {
      return handleTextChange(item.id, e.target.value);
    },
    error: item.error
  })), /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: {
      default: '2/12',
      ss: '1/12',
      md: '1/12'
    }
  }, /*#__PURE__*/_react.default.createElement(_button.IconButton, {
    variant: "text",
    color: "dark",
    label: "Move checklist item up",
    hideLabel: true,
    onClick: function onClick() {
      return handleMoveItem(item.id, _constants.MOVE_DIRECTION.UP);
    },
    disabled: index === 0
  }, /*#__PURE__*/_react.default.createElement(_icons.ArrowUp, null))), /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: {
      default: '2/12',
      ss: '1/12',
      md: '1/12'
    }
  }, /*#__PURE__*/_react.default.createElement(_button.IconButton, {
    variant: "text",
    color: "dark",
    label: "Move checklist item down",
    hideLabel: true,
    onClick: function onClick() {
      return handleMoveItem(item.id, _constants.MOVE_DIRECTION.DOWN);
    },
    disabled: index === checklistItems.length - 1
  }, /*#__PURE__*/_react.default.createElement(_icons.ArrowDown, null))), /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    size: {
      default: '2/12',
      ss: '1/12',
      md: '1/12'
    }
  }, /*#__PURE__*/_react.default.createElement(_button.IconButton, {
    variant: "text",
    color: "dark",
    label: "Delete checklist item",
    hideLabel: true,
    onClick: function onClick() {
      return handleRemoveItem(item.id);
    }
  }, /*#__PURE__*/_react.default.createElement(_icons.Delete, null))));
};

EditChecklistItem.propTypes = {
  item: _propTypes.default.object.isRequired,
  index: _propTypes.default.number.isRequired,
  checklistItems: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string.isRequired,
    text: _propTypes.default.string.isRequired
  })).isRequired,
  newItemTitle: _propTypes.default.string.isRequired,
  newItemDescription: _propTypes.default.string,
  handleTextChange: _propTypes.default.func.isRequired,
  handleMoveItem: _propTypes.default.func.isRequired,
  handleRemoveItem: _propTypes.default.func.isRequired
};
var _default = EditChecklistItem;
exports.default = _default;